module.exports = __webpack_public_path__ + "img/language.a584802a.png";